"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeEmptyQuotationStatus = void 0;
function makeEmptyQuotationStatus() {
    return {
        id: 0,
        code: '',
        name: '',
    };
}
exports.makeEmptyQuotationStatus = makeEmptyQuotationStatus;
//# sourceMappingURL=QuotationStatus.js.map